import React from 'react';
import PropTypes from 'prop-types';
import { AutoSizer, Table, Column } from 'react-virtualized';
import { formatDate } from '../utils/documentHelpers';

const DocumentTable = ({ documents }) => {
    const uniqueSites = new Set(documents.map((d) => d.siteName).filter(Boolean)).size;
    const uniqueCategories = new Set(documents.map((d) => d.category).filter(Boolean)).size;

    const rowGetter = ({ index }) => documents[index];

    const rowClassName = ({ index }) => {
        if (index < 0) return 'document-table__header-row';
        return index % 2 === 0 ? 'document-table__row--even' : 'document-table__row--odd';
    };

    const titleRenderer = ({ cellData }) => (
        <span className="document-table__cell--truncated" title={cellData}>
            {cellData}
        </span>
    );

    const dateRenderer = ({ rowData }) => formatDate(rowData.dateUploaded);

    const downloadRenderer = ({ rowData }) => {
        if (!rowData.fileName) return null;
        return (
            <a
                className="document-table__download-link"
                href={rowData.fileName}
                target="_blank"
                rel="noopener noreferrer"
                download
            >
                Download
            </a>
        );
    };

    return (
        <div className="document-overview">
            <div className="document-overview__chips">
                <span className="document-overview__chip">
                    Documents: <strong>{documents.length}</strong>
                </span>
                <span className="document-overview__chip">
                    Sites: <strong>{uniqueSites}</strong>
                </span>
                <span className="document-overview__chip">
                    Categories: <strong>{uniqueCategories}</strong>
                </span>
            </div>
            <div className="document-overview__table">
                <AutoSizer>
                    {({ width, height }) => (
                        <Table
                            width={width}
                            height={height}
                            headerHeight={36}
                            rowHeight={40}
                            rowCount={documents.length}
                            rowGetter={rowGetter}
                            rowClassName={rowClassName}
                        >
                            <Column label="Category" dataKey="category" width={150} flexGrow={1} />
                            <Column
                                label="Title"
                                dataKey="title"
                                width={250}
                                flexGrow={2}
                                cellRenderer={titleRenderer}
                            />
                            <Column label="Site" dataKey="siteName" width={180} flexGrow={1} />
                            <Column label="Client" dataKey="clientName" width={150} flexGrow={1} />
                            <Column
                                label="Uploaded"
                                dataKey="dateUploaded"
                                width={100}
                                cellRenderer={dateRenderer}
                            />
                            <Column
                                label="Download"
                                dataKey="fileName"
                                width={90}
                                cellRenderer={downloadRenderer}
                            />
                        </Table>
                    )}
                </AutoSizer>
            </div>
        </div>
    );
};

DocumentTable.propTypes = {
    documents: PropTypes.array.isRequired,
};

export default DocumentTable;
